import { render, staticRenderFns } from "./checkboxes-values.vue?vue&type=template&id=0c08d4fe&scoped=true"
import script from "./checkboxes-values.vue?vue&type=script&lang=js"
export * from "./checkboxes-values.vue?vue&type=script&lang=js"
import style0 from "./checkboxes-values.vue?vue&type=style&index=0&id=0c08d4fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08d4fe",
  null
  
)

export default component.exports